import { jsx as _jsx } from "react/jsx-runtime";
import { IconLink } from './SocialButtons.styled';
var SocialLink = function (_a) {
    var url = _a.url, title = _a.title, children = _a.children;
    if (!url) {
        return null;
    }
    return (_jsx(IconLink, { target: "_blank", rel: "noreferrer", href: url, title: title, children: children }));
};
export default SocialLink;
//# sourceMappingURL=SocialLink.js.map